import dateFormat from "dateformat";
export const changeToRupiah = (price) => {
    var rev = parseInt(price, 10).toString().split("").reverse().join("");
    var rev2 = "";
    for (var i = 0; i < rev.length; i++) {
        rev2 += rev[i];
        if ((i + 1) % 3 === 0 && i !== rev.length - 1) {
            rev2 += ".";
        }
    }
    return (
        "Rp. " + rev2.split("").reverse().join("")
    );
}
export const numberFormat = (str) => {
    str = str ? str.toString() : "0";
    return str.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');;
}
export const displayDate = (d, f = 'd mmmm, yyyy') => {
    return d ? dateFormat(d, f) : '';
}
export const filterDisplayDate = (d) => {
    return d ? dateFormat(d, 'd mmmm yyyy') : '';
}

export const getDaysDifference = (startDate, endDate) => {
    const oneDay = 24 * 60 * 60 * 1000;
    const startMillis = startDate.getTime();
    const endMillis = endDate.getTime();
    const differenceMillis = endMillis - startMillis;
    const differenceDays = differenceMillis / oneDay;
    return parseInt(differenceDays);
}

export const toBoolean = (value) => {
    if (typeof value === 'string') {
        value = value.toLowerCase();
        if (value === 'true' || value === '1') {
            return true;
        } else if (value === 'false' || value === '0' || value === '' || value === null || value === undefined) {
            return false;
        }
    } else if (typeof value === 'number') {
        return value === 1;
    } else if (typeof value === 'boolean') {
        return value;
    }
    return false;
}